import getIn from '../utils/getIn';
import React, { ReactNode } from 'react';
import HeaderStatus from '../HeaderStatus';
import { IStatusFlag } from './HeaderBlock';

export const getStatusIndicator = (statusFlag, value) => {
  if (!statusFlag.status) return null;

  if (!value) return null;
  let statusInd: React.ReactNode;
  for (let i = 0; i < statusFlag.status.length; i++) {
    const option = statusFlag.status[i];
    if (value === option.value) {
      let title: string = option.title;
      if (option.titleKey) {
        const titleValue = getIn(value, option.titleKey);
        title = title ? `${title} ${titleValue}` : titleValue;
      } else if (!title) {
        title = value;
      }

      statusInd = (
        <HeaderStatus
          key={`${statusFlag.key}_${i}`}
          icon={option.icon}
          statusStyle={option.style}
          title={title}
          tooltip={option.tooltip}
        />
      );
    }
  }
  return statusInd;
};

export const getStatusIndicatorFromValues = (statusFlag: IStatusFlag, values: any): ReactNode[] => {
  if (!statusFlag.key) {
    return [];
  } else if (statusFlag.override) {
    return statusFlag.status.map((status) => {
      return (
        <HeaderStatus
          key={statusFlag.key + status.title}
          icon={status.icon}
          statusStyle={status.style}
          title={status.title}
          tooltip={status.tooltip}
        />
      );
    });
  }

  const valueOrValues = getIn(values, statusFlag.key);
  const newStatusIndicators: ReactNode[] = [];
  if (Array.isArray(valueOrValues)) {
    valueOrValues.forEach((value) => {
      newStatusIndicators.push(getStatusIndicator(statusFlag, value));
    });
  } else {
    newStatusIndicators.push(getStatusIndicator(statusFlag, valueOrValues));
  }
  return newStatusIndicators;
};
